<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>用户列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.userName" placeholder="用户名" class="handle-input mr10"></el-input>
				<el-input v-model="query.realName" placeholder="真实姓名" class="handle-input mr10"></el-input>
				<el-input v-model="query.tel" placeholder="联系电话" class="handle-input mr10"></el-input>
				<el-select v-model="query.role" placeholder="请选择角色">
					<el-option key="" label="请选择角色" value=""></el-option>
					<el-option key=1 label="企业管理员" :value=1></el-option>
					<el-option key=2 label="部门管理员" :value=2></el-option>
					<el-option key=3 label="一般用户" :value=3></el-option>
				</el-select>
				&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key=false label="禁用" :value=false></el-option>
					<el-option key=true label="启用" :value=true></el-option>
				</el-select>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="userName" label="用户名"></el-table-column>
                <el-table-column prop="realName" label="真实姓名"></el-table-column>
				<el-table-column prop="tel" label="联系电话"></el-table-column>
				<el-table-column prop="post" label="职务"></el-table-column>
				<el-table-column prop="role" label="角色" :formatter = "roleFormat"></el-table-column>
				<el-table-column prop="departmentId" label="部门" width = "200px" :formatter = "departmentFormat"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter = "statusFormat"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-news"
                            @click="unlockUser(scope.$index, scope.row)"
							v-if = "controll['unlock'] && scope.row.lockTime > 0"
                        >解锁</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if = "controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if = "controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if = "controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if = "controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-form-item label="用户名" prop="userName">
					<el-input v-model="form.userName" maxlength="100" :disabled="isDisabled"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password" v-if = !this.form.id>
					<el-input v-model="form.password" type="password" maxlength="18"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="passwordConfirm" v-if = !this.form.id>
					<el-input v-model="form.passwordConfirm" type="password" maxlength="18"></el-input>
				</el-form-item>
				
				
				<el-form-item label="所属部门" prop="departmentInfo">
					<el-input v-model="form.departmentInfo" readonly style="width:300px" clearable></el-input>
					<el-link type="primary" style = "margin-left:10px;" :underline="false" @click="departmentVisible = true">选择</el-link>
					<el-link type="warning" style = "margin-left:10px;" :underline="false" @click="deleteDepartment" v-if="form.departmentInfo">清除</el-link>
				</el-form-item>
				
				<!-- <el-form-item label="角色" prop="role">
					<el-select v-model="form.role" placeholder="请选择角色" @change="roleChange">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option key=1 label="企业管理员" :value=1></el-option>
						<el-option key=2 label="部门管理员" :value=2></el-option>
						<el-option key=3 label="一般用户" :value=3></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="权限" prop="userAuthorityId">
					<el-select v-model="form.userAuthorityId" placeholder="请选择权限">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option v-for="item in userAuthorityKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
					<el-link type="primary" style = "margin-left:10px;" :underline="false" @click="handleAuthority" v-if="!(form.userAuthorityId == undefined || form.userAuthorityId == '')">细化</el-link>
					<el-link type="warning" style = "margin-left:10px;" :underline="false" @click="deleteAuthority" v-if="form.authority">还原</el-link>
				</el-form-item>
				<el-form-item label="职务" prop="post">
					<el-input v-model="form.post"></el-input>
				</el-form-item>
				<!--<el-form-item label="分组" prop="groupId">
					<el-select v-model="form.enumCode" placeholder="请选择职务类型" @change="onChangeGroupType" style="width:150px">
							<el-option key="" label="请选择" value=""></el-option>
							<el-option v-for="item in postionKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
						</el-select>&nbsp;-
						<el-select v-model="form.groupId" placeholder="请选择分组" style="width:150px">
							<el-option key="" label="请选择" value=""></el-option>
							<el-option v-for="item in groupKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
						</el-select>
					</el-select>
				</el-form-item>-->
				<el-form-item label="状态" prop="status">
					<el-select v-model="form.status" placeholder="请选择状态">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option key=false label="禁用" :value=false></el-option>
						<el-option key=true label="启用" :value=true></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="消息推送" prop="pushMessageEnable">
					<el-switch v-model="form.pushMessageEnable"></el-switch>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="权限细化" :visible.sync="authorityVisible" width="60%">
            <div style="margin-left:50px;margin-right:50px;">
				<v-AuthoritySet ref="authorityTree"></v-AuthoritySet>
			</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="authorityVisible = false">取 消</el-button>
                <el-button type="primary" @click="setAuthroity" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="部门信息" :visible.sync="departmentVisible" width="30%">
            <el-input
			  placeholder="输入关键字进行过滤"
			  v-model="departmentFilterText">
			</el-input>
			<div style="padding-top:5px; margin-top:10px;border:1px solid #cbcccc;">
				<el-tree
					:data="departmentOptions"
					node-key="id"
					default-expand-all
					:filter-node-method="filterNode"
					@node-click="departmentTreeDblClick"
					ref="departmentTree">
				</el-tree>
			</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="departmentVisible = false">取 消</el-button>
                <el-button type="primary" @click="selectDepartment" v-prevent-re-click>确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchUserData, saveUser, deleteUser, getUser, getEnumValueKV, unlock, getDepartmentTreeData,
getAuthorityRouteTreeData, getCompanyAuthority, getUserAuthorityKVByDepartmentId,
getPostionKV, getUserAuthority, getUserAuthorityKV} from '../../../api/index';
import vAuthoritySet from '../../common/AuthoritySet.vue';
export default {
    name: 'user',
    data() {
		let validatePass = (rule, value, callback) => {
			if (!this.form.id) {
				if (!value) {
					callback(new Error('请输入新密码'));
				} else if (value.toString().length < 6 || value.toString().length > 18) {
					callback(new Error('密码长度为6 - 18个字符'))
				} else {
					callback();
				}
			}
		};
		let validatePass2 = (rule, value, callback) => {
			if (!this.form.id) {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.form.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			}
		};
        return {
            query: {
                companyCode: '',
                userName: '',
                pageNum: 1,
                pageSize: 10
            },
			enumValueKV:[],
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			rules: {
                userName: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
				password: [{ required: true, validator:validatePass, trigger: 'blur' }],
				passwordConfirm: [{ required: true, validator: validatePass2, trigger: 'blur' }],
				departmentInfo:[{ required: true, message: '请选择部门', trigger: 'blur' }],
				userAuthorityId:[{ required: true, message: '请选择权限', trigger: 'blur' }],
				role: [{ required: true, message: '请选择角色', trigger: 'blur' }],
				status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
            },
			treeDatasource:[],
			applyCompanyKeys:[],
			postionKV:[],
			groupKV:[],
			userAuthorityKV:[],
			authorityVisible:false,
			controll:{},
			departmentVisible:false,
			departmentFilterText:"",
			departmentOptions: [],
			lastClickTime: 0,
			departmentMapping:{}
		};
    },
	watch: {
      departmentFilterText(val) {
        this.$refs.departmentTree.filter(val);
      }
    },
    created() {
		this.controll = getControll("user");
        this.getData();
		this.getRouteTreeData();
		this.getOwnCompanyAuthority();
		this.getPostion();
		this.getDepartmentData();
    },
	components: {
        vAuthoritySet
    },
    methods: {
		getDepartmentData() {
            getDepartmentTreeData().then(res => { 
				if (res.code == 0 ) {
					this.departmentOptions = res.data;
					this.getDepartmentMapping(res.data, undefined);
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
		departmentTreeDblClick(data, node) {
			//this.$refs.departmentTree
			const currentTime = Date.now();
			if (currentTime - this.lastClickTime < 300) { // 300ms内视为双击
				this.$set(this.form, "departmentId", data.id);
				this.$set(this.form, "departmentFirstParentId", this.departmentMapping[data.id]["firstParentId"]);
				this.$set(this.form, "departmentInfo", this.departmentMapping[data.id]["name"]);
				this.departmentVisible = false;
				this.getAuthoritys(this.departmentMapping[data.id]["firstParentId"]);
			} else {
				// 如果是单击，可以在这里处理其他逻辑，如展开/折叠节点等
			}
			this.lastClickTime = currentTime; // 更新上次点击时间
		},
		selectDepartment() {
			let selected = this.$refs.departmentTree.getCurrentNode();
			if (selected == undefined) {
				this.$message.error("请选择部门");
				return;
			}
			this.$set(this.form, "departmentId", selected.id);
			this.$set(this.form, "departmentFirstParentId", this.departmentMapping[selected.id]["firstParentId"]);
			this.$set(this.form, "departmentInfo", this.departmentMapping[selected.id]["name"]);
			this.departmentVisible = false
			this.getAuthoritys(this.departmentMapping[selected.id]["firstParentId"]);
		},
		deleteDepartment() {
			this.$set(this.form, "departmentId", undefined);
			this.$set(this.form, "departmentFirstParentId", undefined);
			this.$set(this.form, "departmentInfo", undefined);
		},
		getDepartmentMapping(nodes, parentMapping) {
			for(let i = 0; i < nodes.length; i++) {
				let node = nodes[i]
				let mapping = {}
				if (parentMapping) {
					mapping["firstParentId"] = parentMapping["firstParentId"];
					mapping["name"] = parentMapping["name"] + " / " + node.label
				} else {
					mapping["firstParentId"] = node.id;
					mapping["name"] = node.label
				}
				this.departmentMapping[node.id] = mapping
				if (node.children && node.children.length > 0) {
					this.getDepartmentMapping(node.children, mapping)
				}
			}
		},
		getAuthoritys(departmentId, userAuthorityId) {
			if (departmentId != this.form["departmentFirstParentId"]) {
				this.$set(this.form, "userAuthorityId", "");
				this.$set(this.form, "authority", "");
			}
			getUserAuthorityKVByDepartmentId(departmentId).then(res => {
				if (res.code == 0 ) {
					this.userAuthorityKV = res.data;
					if (userAuthorityId != undefined) {
						this.$set(this.form, "userAuthorityId", userAuthorityId);
					}
				} else {
					this.$message.error("获取权限数据失败！" + res.message);
				}
			})
		},
		//打开权限细化
		handleAuthority() {
			if (this.form["userAuthorityId"] == undefined || this.form["userAuthorityId"] == "") {
				this.$message.error("请先选择权限！");
				return;
			}
			//获取用户角色权限内容
			getUserAuthority(this.form["userAuthorityId"]).then(res => {
				if (res.code == 0 ) {
					let selectAuthorityKeys = [];
					//读取用户角色权限内容
					if (!(res.data.authority == undefined || res.data.authority == "")) {
						this.selectAuthorityKeys = JSON.parse(res.data.authority);
					}
					//打开细化窗口
					this.authorityVisible = true;
					this.$nextTick(()=>{
						//如果没有细化权限，默认按照用户角色权限全选，如有细化权限，则按照细化权显示
						if (this.form.authority == undefined || this.form.authority == "") {
							this.$refs.authorityTree.setDatasource(this.treeDatasource, this.selectAuthorityKeys, this.selectAuthorityKeys);
						} else {
							let checkedKeys = JSON.parse(this.form.authority)
							this.$refs.authorityTree.setDatasource(this.treeDatasource, checkedKeys, this.selectAuthorityKeys);
						}
					});
				} else {
					this.$message.error("获取用户权限内容失败！" + res.message);
				}
			});
		},
		//设置细化权限
		setAuthroity() {
			let checkedKeys = this.$refs.authorityTree.getCheckedKeys();
			this.$set(this.form, "authority", JSON.stringify(checkedKeys));
			this.authorityVisible = false;
		},
		//细化权限清除
		deleteAuthority() {
			this.$set(this.form, "authority", "");
		},
		//角色变更
		roleChange(value) {
			this.userAuthorityKV = [];
			this.$set(this.form, "userAuthorityId", "");
			this.$set(this.form, "authority", "");
			if (value == undefined || value == ""){
				return;
			}
			getUserAuthorityKV(value).then(res => { 
				if (res.code == 0 ) {
					this.userAuthorityKV = res.data;
				} else {
					this.$message.error("获取用户权限数据失败！" + res.message);
				}
            });
		},
		getPostion() {
			this.postionKV = [];
			getPostionKV().then(res => { 
				if (res.code == 0 ) {
					this.postionKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
		},
		//状态格式化
		statusFormat(row, column, cellValue) {
			if (cellValue == '0') {
				return '禁用';
			} else {
				return '启用';
			}
		},
		// 获取树形结构数据
        getRouteTreeData() {
            getAuthorityRouteTreeData().then(res => { 
				if (res.code == 0 ) {
					this.treeDatasource = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		getOwnCompanyAuthority() {
			getCompanyAuthority().then(res => { 
				if (res.code == 0 ) {
					this.applyCompanyKeys = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
		},
		roleFormat(row, column, cellValue) {
			if (cellValue == 1) {
				return '企业管理员';
			} else if (cellValue == 2){
				return '业务管理员';
			} else {
				return '一般用户';
			}
		},
		departmentFormat(row, column, cellValue) {
			if (cellValue == "" || cellValue == undefined) {
				return "";
			}
			if (this.departmentMapping[cellValue]) {
				return this.departmentMapping[cellValue]["name"];
			} else {
				return "";
			}
		},
		//获取枚举
		onChangeGroupType(value) {
			this.groupKV = [];
			if (!value) {
				return;
			}
			getEnumValueKV(value).then(res => {
				if (res.code == 0 ) {
					this.groupKV = res.data;
				} else {
					this.$message.error("获取分组失败！" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchUserData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteUser([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteUser(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
			this.isDisabled = false;
		},
        // 编辑操作
        handleEdit(index, row) {
			this.title = "编辑";
			getUser(row.id).then(res => {
				if (res.code == 0) {
					//this.roleChange(res.data.role);
					//this.onChangeGroupType(res.data.enumCode);
					this.form = res.data;
					if (res.data.departmentId) {
						let firstParentId = this.departmentMapping[res.data.departmentId]["firstParentId"];
						this.$set(this.form, "departmentFirstParentId", firstParentId);
						this.getAuthoritys(firstParentId, res.data.userAuthorityId);
						if (this.form["departmentId"]) {
							this.$set(this.form, "departmentInfo", this.departmentMapping[this.form["departmentId"]]["name"])
						}
					}
					this.editVisible = true;
					this.isDisabled = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveUser(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		unlockUser(index, row) {
			this.$confirm('确定要解锁' + row.userName + '用户吗？', '提示', {
                type: 'warning'
            }).then(() => {
				unlock(row.id).then(res => {
					if (res.code == 0) {
						this.$message.success('解锁成功！');
						this.getData();
					} else {
						this.$message.error(`解锁失败！` + res.message);
					}
				});
			}).catch(() => {});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
